import { ChevronLeft, ChevronRight } from '@mui/icons-material'
import DayCell from '../day-cell/day-cell.component'
import {
  DayOfWeek,
  Grid,
  Header,
  MonthYearDisplay,
  NavButton,
  PopupContainer,
} from './calendar-popup.styles'

interface IProps {
  range: { start: Date | null; end: Date | null }
  onDayClick: (
    day: Date,
    range: { start: Date | null; end: Date | null },
    setRange: (newRange: { start: Date | null; end: Date | null }) => void,
    setIsOpen: (isOpen: boolean) => void
  ) => void
  setRange: (newRange: { start: Date | null; end: Date | null }) => void
  setIsOpen: (isOpen: boolean) => void
  goToPrevMonth: () => void
  goToNextMonth: () => void
  monthYearDisplay: string
  calendarDays: (Date | null)[]
}

const daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']

const CalendarPopup = ({
  range,
  onDayClick,
  setRange,
  setIsOpen,
  goToPrevMonth,
  goToNextMonth,
  monthYearDisplay,
  calendarDays,
}: IProps) => {
  const handlePrevMonth = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    e.stopPropagation()
    goToPrevMonth()
  }

  const handleNextMonth = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    e.stopPropagation()
    goToNextMonth()
  }

  return (
    <PopupContainer>
      <Header>
        <NavButton type="button" onClick={handlePrevMonth}>
          <ChevronLeft />
        </NavButton>
        <MonthYearDisplay>{monthYearDisplay}</MonthYearDisplay>
        <NavButton type="button" onClick={handleNextMonth}>
          <ChevronRight />
        </NavButton>
      </Header>

      <Grid style={{ marginBottom: '0.5rem' }}>
        {daysOfWeek.map((day) => (
          <DayOfWeek key={day}>{day}</DayOfWeek>
        ))}
      </Grid>

      <Grid>
        {calendarDays.map((day, index) => (
          <DayCell
            key={index}
            day={day}
            range={range}
            onDayClick={onDayClick}
            setIsOpen={setIsOpen}
            setRange={setRange}
          />
        ))}
      </Grid>
    </PopupContainer>
  )
}

export default CalendarPopup
